var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInboxUnarchiveFill = function SvgInboxUnarchiveFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.2 3.9 21 7.5v11.7a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V7.504L4.8 3.9zM12 10.2l-3.6 3.6h2.7v3.6h1.8v-3.6h2.7zm6.088-4.5H5.912l-.899 1.8h13.975z"
  })));
};
export default SvgInboxUnarchiveFill;